// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    
    async fetchSendMqtt({ commit, rootGetters }, payload){
        try {
            const access_token = rootGetters.access_token;
            const response = await axios.post(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/MQTT/send-mqtt`,
                {
                    rhg_id: payload.rhg_id,
                    rhg_port: payload.rhg_port,
                    CA_addr: payload.CA_addr,
                    CTRL: payload.CTRL,
                    Value: payload.Value
                },
                {
                    headers: {
                        'Authorization': `${access_token}`
                    }
                }
            );


            return {
                status: response.status,
                data: response.data
            };
        } catch (error) {
            if (error.response) {
                // Сервер вернул ответ с ошибкой (код статуса не в диапазоне 2xx)
                return {
                    status: error.response.status,
                    message: error.response.data.message || 'Registration failed'
                };
            } else if (error.request) {
                // Запрос был сделан, но ответа не получено
                return {
                    status: 0,
                    message: 'No response received from server'
                };
            } else {
                // Что-то пошло не так при настройке запроса
                return {
                    status: -1,
                    message: error.message
                };
            }
        }
    }
};
